export enum Endpoints {
  StablePrice = '/stable-price-close',
};